export default {
  viewServices: {
    is: 'Sjá þjónustu í boði',
    en: 'View on map',
  },
};
